import React from "react";

const Footer = () => {
  const paymentMethods = [
    "EcoCash",
    "Visa & MasterCard",
    "PayPal",
    "WhatsApp Orders",
  ];

  return (
    <footer role="contentinfo" className="footer text-black py-5 px-3 mt-auto logo">
      <div className="container">
        {/* Main Footer Content */}
        <div className="row text-start mb-4">
          {/* About Us */}
          <div className="col-12 col-lg-4 mb-4 mb-lg-0">
            <h5 className="text-uppercase text-black mb-3">About Us</h5>
            <p className="text-black mb-3">
              Farmhouse Store is your one-stop online destination for premium fresh fruits and vegetables.
            </p>
            <p className="text-black small">Committed to serving freshness since 2024</p>
          </div>

          {/* Get in Touch */}
          <div className="col-12 col-lg-4 mb-4 mb-lg-0">
            <h5 className="text-uppercase text-black mb-3">Get in Touch</h5>
            <p className="text-black mb-3">Contact us for any inquiries or assistance.</p>
            <div className="mb-3">
              <p className="text-black mb-2">Dial/WhatsApp:</p>
              <a
                href="tel:+263777160749"
                className="text-black text-decoration-none fw-bold fs-5 d-block"
              >
                +263 777 160 749
              </a>
            </div>

            <div className="mt-3 p-2 bg-white bg-opacity-20 border-start border-black border-2 rounded-end">
              <small className="text-black d-block">
                <strong>Delivery Policy:</strong> Orders outside standard zone incur additional fees. Contact us for quotes.
              </small>
            </div>
          </div>

          {/* Payment Methods */}
          <div className="col-12 col-lg-4 mb-4 mb-lg-0">
            <h5 className="text-uppercase text-black mb-3">Payment Methods</h5>
            <ul className="list-unstyled text-black ps-3">
              {paymentMethods.map((method, index) => (
                <li key={index} className="mb-2">• {method}</li>
              ))}
            </ul>
          </div>
        </div>

        {/* Important Notice Section */}
        <div className="row mb-4">
          <div className="col-12">
            <div className="p-4 bg-white bg-opacity-15 border-black border border-opacity-25 rounded">
              <h6 className="fw-bold text-black mb-2">Important Delivery Information</h6>
              <ul className="text-warning small ps-3 mb-0">
                <li>Deliveries are done every Wednesday.</li>
                <li>Orders placed after Wednesday will be delivered the following Wednesday.</li>
                <li>Areas beyond our standard 15km delivery zone from Highlands Park, Harare will incur additional delivery charges.</li>
              </ul>
            </div>
          </div>
        </div>

        <hr className="border-top border-black border-opacity-50 my-4" />

        {/* Copyright */}
        <div className="text-center">
          <p className="mb-2 text-black">
            <span className="text-black fw-bold">Farmhouse Store</span> - Premium Fresh Fruits & Vegetables
          </p>
          <p className="mb-0 small text-black opacity-75">
            &copy; {new Date().getFullYear()} Farmhouse Store. All rights reserved. | Fast, reliable delivery across Harare and surrounding areas
          </p>
        </div>
      </div>

      <style jsx>{`
        .footer {
          background: #f5f5f5;
          box-shadow: 0 -4px 20px rgba(0, 0, 0, 0.2);
        }

        @media (max-width: 768px) {
          .footer .p-3 {
            padding: 0.75rem !important;
          }

          .footer .mb-3 {
            margin-bottom: 1rem !important;
          }

          .footer .fs-5 {
            font-size: 1.1rem !important;
          }
        }

        @media (max-width: 576px) {
          .footer .col-6 {
            margin-bottom: 0.75rem;
          }

          .footer .p-4 {
            padding: 1rem !important;
          }

          .footer .border-start {
            border-left-width: 2px !important;
          }
        }
      `}</style>
    </footer>
  );
};

export default Footer;
